import React, { useEffect, useState } from 'react';
import SelectInput from '../forms/inputs/select';
import { Provider } from '../forms/utilities/form-context';
import FormItem from '../forms/utilities/form-item';
import { jsonParse } from '../Libraries/helpers';
import BubbleLoader from '../Libraries/Loader/bubble-loader';

const MasterWarranty = props => {
    const i18n = jsonParse(props.i18n)
    const [products, setProducts] = useState([])
    const [type, setType] = useState(null);
    const [model, setModel] = useState({ id: '' });

    const fetchProducts = async () => {
        const { data } = await axios.get(props.dataSource)

        setProducts(data)
    }

    const updateProduct = id => {
        setModel({ id: '' })
        setType(products.find(i => `${i.id}` === id))
    }

    const updateModel = ({ target }) => {
        const result = type.models.find(i => `${i.id}` === target.value) || { id: '' }

        setModel(result)
    }

    useEffect(() => {
        fetchProducts();
    }, [])

    return <Provider i18n={ i18n }>
        { !products.length ? <BubbleLoader /> : <>

            <div className={'prose'}>
                <h3>{ i18n.heading }</h3>
            </div>

            <div className={'mt-6 flex flex-wrap'}>
                <div className={'w-full sm:w-1/2'}>
                    <FormItem name="product_type">
                        <SelectInput options={ products.map(item => ({
                            label: item.name,
                            value: item.id,
                        })) } onChange={ updateProduct } />
                    </FormItem>
                </div>
                { type && <div className={'mt-2 sm:mt-0 w-full sm:w-1/2'}>
                    <FormItem name="model">
                        <div className="js-form-label small-label relative">
                            <label htmlFor="model_picker">
                                { i18n.model }
                            </label>

                            <select
                                className="styled-input"
                                id="model_picker"
                                onChange={ updateModel }
                                value={ model.id }
                            >
                                <option disabled value="">{ i18n.please_select }</option>
                                { type.models.map(option => {
                                    return <option key={ option.id } value={ option.id }>
                                        { option.name }
                                    </option>
                                })}
                            </select>
                        </div>
                    </FormItem>
                </div> }
            </div>

            { model.id && <div>
                <div className="mt-6 auto-bullets">

                    <div className={'prose'}>
                        <h3>{ i18n.sub_heading } { model.name }</h3>
                    </div>

                    <ul className={'mt-4'}>
                        { model.parts.map(item => <li key={ item.id } className="text-sm md:text-base text-black mt-3  flex items-center">
                            <div>
                                <svg width="22" height="21" viewBox="0 0 22 21" xmlns="http://www.w3.org/2000/svg">
                                    <g transform="translate(1 .5)" fill="none" fillRule="evenodd">
                                        <path d="M3.24 10.57l4.315 4.324 8.289-8.28-1.19-1.174-7.099 7.09-3.142-3.142z" fill="#414248" fillRule="nonzero"/>
                                        <circle stroke="#414248" cx="9.811" cy="9.811" r="9.811"/>
                                    </g>
                                </svg>
                            </div>
                            <div className="pl-5">
                                { item.name }
                            </div>
                        </li>) }
                    </ul>
                </div>
            </div>}
        </> }
    </Provider>
}

export default MasterWarranty
